<template>
  <div class="app-container" :class="{ 'mobile-view': isMobile, 'sidebar-open': isSidebarOpen }">
    <!-- 侧边栏 -->
    <div class="sidebar" :class="{ 'mobile-sidebar': isMobile, 'collapsed': isCollapsed && !isMobile }">
      <div class="logo">
        <div class="logo-content">
          <h1>{{ platformTitle }}</h1>
          <p>医院管理平台</p>
        </div>
        <button v-if="!isMobile" @click="toggleCollapse" class="collapse-button"
          :title="isCollapsed ? '展开侧边栏' : '收起侧边栏'">
          <el-icon>
            <DArrowLeft v-if="!isCollapsed" />
            <DArrowRight v-if="isCollapsed" />
          </el-icon>
        </button>
      </div>
      <nav class="menu">
        <!-- 数据总览 -->
        <div class="nav-section">
          <div class="nav-section-title">数据总览</div>
          <router-link to="/dashboard" custom v-slot="{ navigate, isActive }">
            <button @click="navigate" class="menu-item" :class="{ active: isActive }">
              <el-icon class="menu-icon">
                <Monitor />
              </el-icon>
              <span class="fontw menu-text">控制台</span>
            </button>
          </router-link>
        </div>

        <!-- 护理管理 -->
        <div class="nav-section">
          <div class="nav-section-title">护理管理</div>
          <router-link to="/caregiver-management" custom v-slot="{ navigate, isActive }">
            <button @click="navigate" class="menu-item" :class="{ active: isActive }">
              <el-icon class="menu-icon">
                <User />
              </el-icon>
              <span class="fontw menu-text">康护质控</span>
            </button>
          </router-link>
          <router-link to="/order-management" custom v-slot="{ navigate, isActive }">
            <button @click="navigate" class="menu-item" :class="{ active: isActive }">
              <el-icon class="menu-icon">
                <List />
              </el-icon>
              <span class="fontw menu-text">护理订单</span>
            </button>
          </router-link>
          <router-link to="/service-object-management" custom v-slot="{ navigate, isActive }">
            <button @click="navigate" class="menu-item" :class="{ active: isActive }">
              <el-icon class="menu-icon">
                <Avatar />
              </el-icon>
              <span class="fontw menu-text">服务对象</span>
            </button>
          </router-link>
          <router-link to="/care-report-list" custom v-slot="{ navigate, isActive }">
            <button @click="navigate" class="menu-item" :class="{ active: isActive }">
              <el-icon class="menu-icon">
                <Notebook />
              </el-icon>
              <span class="fontw menu-text">护理记录</span>
            </button>
          </router-link>
        </div>

        <!-- 机构管理 -->
        <div class="nav-section">
          <div class="nav-section-title">机构管理</div>
          <router-link to="/employee-management" custom v-slot="{ navigate, isActive }">
            <button @click="navigate" class="menu-item" :class="{ active: isActive }">
              <el-icon class="menu-icon">
                <Suitcase />
              </el-icon>
              <span class="fontw menu-text">职工管理</span>
            </button>
          </router-link>
          <router-link to="/department-management" custom v-slot="{ navigate, isActive }">
            <button @click="navigate" class="menu-item" :class="{ active: isActive }">
              <el-icon class="menu-icon">
                <Grid />
              </el-icon>
              <span class="fontw menu-text">{{ departmentText }}</span>
            </button>
          </router-link>
          <router-link to="/company-management" custom v-slot="{ navigate, isActive }">
            <button @click="navigate" class="menu-item" :class="{ active: isActive }">
              <el-icon class="menu-icon">
                <OfficeBuilding />
              </el-icon>
              <span class="fontw menu-text">护工公司</span>
            </button>
          </router-link>
        </div>

        <!-- 互动与活动 -->
        <div class="nav-section">
          <div class="nav-section-title">互动与活动</div>
          <router-link to="/service-quality-list" custom v-slot="{ navigate, isActive }">
            <button @click="navigate" class="menu-item" :class="{ active: isActive }">
              <el-icon class="menu-icon">
                <Opportunity />
              </el-icon>
              <span class="fontw menu-text">服务质量</span>
            </button>
          </router-link>
          <router-link to="/activity-management" custom v-slot="{ navigate, isActive }">
            <button @click="navigate" class="menu-item" :class="{ active: isActive }">
              <el-icon class="menu-icon">
                <TrendCharts />
              </el-icon>
              <span class="fontw menu-text">活动列表</span>
            </button>
          </router-link>
          <router-link to="/registration-record-management" custom v-slot="{ navigate, isActive }">
            <button @click="navigate" class="menu-item" :class="{ active: isActive }">
              <el-icon class="menu-icon">
                <Document />
              </el-icon>
              <span class="fontw menu-text">报名记录</span>
            </button>
          </router-link>
          <router-link to="/conversation-record" custom v-slot="{ navigate, isActive }">
            <button @click="navigate" class="menu-item" :class="{ active: isActive }">
              <el-icon class="menu-icon">
                <ChatDotRound />
              </el-icon>
              <span class="fontw menu-text">对话记录</span>
            </button>
          </router-link>
        </div>

        <!-- 系统设置 -->
        <div class="nav-section">
          <div class="nav-section-title">系统设置</div>
          <router-link to="/account-settings" custom v-slot="{ navigate, isActive }">
            <button @click="navigate" class="menu-item" :class="{ active: isActive }">
              <el-icon class="menu-icon">
                <List />
              </el-icon>
              <span class="fontw menu-text">账号中心</span>
            </button>
          </router-link>
        </div>
      </nav>

      <!-- 退出登录按钮 -->
      <!-- <div class="logout-section">
        <button @click="handleLogout" class="logout-button">
          <el-icon class="logout-icon">
            <SwitchButton />
          </el-icon>
          <span>退出登录</span>
        </button>
      </div> -->

      <!-- 底部版权信息 -->
      <div class="powered-by">
        <span>powered by 虚实科技</span>
        <!-- <strong>虚实科技</strong> -->
      </div>
    </div>
    <!-- 主内容区域 -->
    <div class="main-content">
      <div class="header-container">
        <!-- 移动端菜单按钮 -->
        <div class="mobile-menu-button" v-if="isMobile" @click="toggleSidebar" style="z-index: 100">
          <el-icon size="24px">
            <Menu />
          </el-icon>
          <h1 class="mobile-title">AI智护管家-医院端</h1>
        </div>
        <div v-else></div>
        <!-- <div class="user-info">
          <el-dropdown v-if="isLoggedIn">
            <span class="el-dropdown-link"> {{ currentHospital?.hospitalName || '医院' }} <el-icon class="el-icon--right">
                <ArrowDown />
              </el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="handleLogout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
</el-dropdown>
</div> -->
      </div>
      <!-- 路由视图 -->
      <router-view />
      <!-- 移动端侧边栏遮罩 -->
      <div class="sidebar-overlay" v-if="isMobile && isSidebarOpen" @click="toggleSidebar"></div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import {
  ArrowDown,
  User,
  Menu,
  ChatDotRound,
  Monitor,
  Reading,
  OfficeBuilding,
  Avatar,
  UserFilled,
  List,
  Opportunity,
  Picture,
  Document,
  Goods,
  SwitchButton,
  DArrowLeft,
  DArrowRight,
  TrendCharts,
  Suitcase,
  Notebook,
  Grid,
} from '@element-plus/icons-vue'

// @ts-ignore: 自定义模块
import { removeToken, clearUserData, getToken, getHospitalInfo, getHospitalType } from '../common/auth'

const router = useRouter()

// 获取医院信息 - 使用 ref 以便能够响应式更新
const currentHospital = ref(getHospitalInfo())

// 刷新医院信息的方法
const refreshHospitalInfo = () => {
  currentHospital.value = getHospitalInfo()
}

// 基于 token 判断登录状态
const isLoggedIn = computed(() => {
  return getToken() !== undefined && getToken() !== null
})

// 获取医院类型并生成动态文字
const hospitalType = ref(getHospitalType())
const isHospital = computed(() => hospitalType.value === '1')
const isCommunity = computed(() => hospitalType.value === '2')

// 动态文字内容
const departmentText = computed(() => {
  return isCommunity.value ? '小区管理' : '科室管理'
})

// 动态平台标题
const platformTitle = computed(() => {
  return isCommunity.value ? '社区护工管理平台' : 'AIcare·爱护无忧'
})



// 响应式变量控制移动端适配
const isMobile = ref(false)
const isSidebarOpen = ref(false)
const isCollapsed = ref(false)

// 检查设备是否为移动端
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768
  // 如果不是移动端，确保侧边栏始终打开
  if (!isMobile.value) {
    isSidebarOpen.value = true
  }
}

// 切换侧边栏显示状态
const toggleSidebar = () => {
  isSidebarOpen.value = !isSidebarOpen.value
}

// 切换侧边栏收起状态
const toggleCollapse = () => {
  isCollapsed.value = !isCollapsed.value
}

// 监听窗口大小变化
onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
  // 监听医院信息更新事件
  window.addEventListener('hospitalInfoUpdated', refreshHospitalInfo)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
  window.removeEventListener('hospitalInfoUpdated', refreshHospitalInfo)
})

const handleLogout = () => {
  // 清除所有认证相关的数据
  removeToken()
  clearUserData()

  // 清除其他localStorage数据
  localStorage.removeItem('communityUserInfo')

  // 清除sessionStorage
  sessionStorage.clear()



  ElMessage.success('已退出登录')

  // 跳转到登录页，添加强制登录参数
  router.push('/login?force=true')
}
</script>
<style scoped>
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 15px 20px; */
  border-bottom: 1px solid #eee;
}

.mobile-menu-button {
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}

.mobile-menu-button .mobile-title {
  color: #3b82f6;
  margin: 0;
  font-size: 20px;
  font-weight: bold;
}

.el-dropdown-link {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.app-container {
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

.sidebar {
  width: 240px;
  background-color: #1a1a1a;
  color: white;
  padding: 20px;
  overflow-y: auto;
  z-index: 2;
}

.sidebar {
  width: 180px;
  height: 100%;
  background: linear-gradient(180deg, #26A69A 0%, #00b3c6 50%, #00c6da 100%);
  color: white;
  flex-shrink: 0;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
  transition: width 0.3s ease, transform 0.3s ease;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

/* 收起状态的侧边栏 */
.sidebar.collapsed {
  width: 70px;
  padding: 20px 6px;
}

.sidebar.collapsed .logo {
  padding: 16px 6px;
}

.sidebar.collapsed .logo-content {
  opacity: 0;
  height: 0;
  overflow: hidden;
  margin: 0;
}

.sidebar.collapsed .nav-section {
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar.collapsed .nav-section:last-of-type {
  border-bottom: none;
}

.sidebar.collapsed .nav-section-title {
  opacity: 0;
  height: 0;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.sidebar.collapsed .menu-text {
  opacity: 0;
  width: 0;
  overflow: hidden;
}

.sidebar.collapsed .powered-by span {
  opacity: 0;
  height: 0;
  overflow: hidden;
}

.sidebar.collapsed .menu-item {
  justify-content: center;
  padding: 12px;
  margin: 6px auto;
  width: 44px;
  height: 44px;
  border-radius: 10px;
}

.sidebar.collapsed .menu-item:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: scale(1.05);
}

.sidebar.collapsed .menu-item.active {
  background: rgba(255, 255, 255, 0.35);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2),
    0 0 0 2px rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.sidebar.collapsed .menu-icon {
  margin-right: 0;
  font-size: 24px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}




.sidebar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, transparent 40%);
  pointer-events: none;
}

.sidebar::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

/* 移动端样式 */
.mobile-view {
  position: relative;
}

.mobile-view .sidebar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  transform: translateX(-100%);
}

.mobile-view.sidebar-open .sidebar {
  transform: translateX(0);
}

.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.logo {
  padding: 20px 16px;
  text-align: center;
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.logo-content {
  transition: all 0.3s ease;
}

.collapse-button {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: white;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
  flex-shrink: 0;
}

.collapse-button:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.sidebar.collapsed .collapse-button {
  width: 44px;
  height: 44px;
  border-radius: 10px;
}

.logo h1 {
  margin: 0;
  font-size: 14px;
  color: white;
  font-weight: 700;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.logo p {
  margin: 2px 0 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.95);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}

.menu {
  padding: 8px 0;
  flex-grow: 1;
  overflow-y: auto;
  position: relative;
}

.nav-section {
  margin-bottom: 4px;
}

.nav-section-title {
  padding: 12px 16px 6px 16px;
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 0.5px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}

.menu-item {
  display: flex;
  align-items: center;
  width: calc(100% - 16px);
  padding: 10px 16px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.95);
  font-size: 15px;
  text-align: left;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  margin: 2px 8px;
  border-radius: 8px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  position: relative;
}

.menu-icon {
  font-size: 20px;
  margin-right: 10px;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.15));
  transition: margin 0.3s ease;
}

.menu-text {
  transition: all 0.3s ease;
  white-space: nowrap;
}

.menu-item:hover {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.menu-item.active {
  background: rgba(255, 255, 255, 0.3);
  color: white;
  font-weight: 600;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.main-content {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  background-color: #f5f5f5;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
  /* padding: 10px 20px 20px 20px; */
  /* PC端内容区域padding */
}

.mobile-view .main-content {
  width: 100%;
  padding: 2px;
  /* 移动端内容区域padding为2px */
}

.main-content::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

.fontw {
  font-weight: 500;
  font-size: 15px;
}

/* 移动端特定样式 */
@media (max-width: 768px) {
  .user-info {
    font-size: 14px;
  }

  .header-container {
    padding: 10px 15px;
    z-index: 2;
  }

  /* 移动端菜单项样式调整 */
  .menu-item {
    padding: 10px 12px;
    margin: 2px 6px;
    width: calc(100% - 12px);
  }

  .logo {
    padding: 15px 12px;
  }

  .nav-section-title {
    padding: 10px 12px 6px 12px;
  }

  .powered-by {
    padding: 10px 12px;
  }

  .logout-section {
    padding: 10px 15px;
  }

  .logout-button {
    padding: 10px 12px;
    font-size: 13px;
  }

  .sidebar {
    width: 240px;
  }
}

/* 退出登录按钮样式 */
.logout-section {
  padding: 15px 20px;

}

.logout-button {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 5px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(48, 144, 241, 0.664);
  border-radius: 8px;
  color: #0085ff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.logout-button:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.25);
  color: #ffffff;
  transform: translateY(-1px);
}

.logout-icon {
  font-size: 16px;
  margin-right: 8px;
}

/* 底部powered by样式 */
.powered-by {
  width: 100%;
  text-align: center;
  padding: 12px 16px;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  position: relative;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}

.powered-by span {
  display: block;
}

.powered-by strong {
  color: white;
  font-weight: 600;
  letter-spacing: 0.5px;
}
</style>
